'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onClick(itemOnClick, closeMenu) {
  itemOnClick();
  closeMenu();
}

var DropdownItem = function DropdownItem(props, _ref) {
  var closeMenu = _ref.closeMenu;

  var boundOnClick = onClick.bind(null, props.onClick, closeMenu);
  return _react2.default.createElement(
    'li',
    { className: _styles2.default.dropdown__item,
      onClick: boundOnClick,
      'data-hudl-element': props.text + '-dropdown-action'
    },
    _react2.default.createElement(
      'span',
      { className: _styles2.default.dropdown__icon },
      props.icon
    ),
    _react2.default.createElement(
      'span',
      { className: _styles2.default.dropdown__text },
      props.text
    )
  );
};

DropdownItem.propTypes = {
  text: _react.PropTypes.string.isRequired,
  icon: _react.PropTypes.element,
  onClick: _react.PropTypes.func.isRequired
};

DropdownItem.contextTypes = {
  closeMenu: _react.PropTypes.func.isRequired
};

exports.default = DropdownItem;